import axios from 'axios';
import { API, authHeaders } from './client';

export const login = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }).then(r => r.data);

export const logout = () =>
  axios.post(`${API}/auth/logout`).then(r => r.data);

export const requestPasswordReset = (email) =>
  axios.post(`${API}/auth/request-password-reset`, { email }).then(r => r.data);

export const resetPassword = (token, new_password) =>
  axios.post(`${API}/auth/reset-password`, { token, new_password }).then(r => r.data);
